<div class="row g-3 p-0 mb-3" *ngIf="cars.length">
  <div class="col-12">
    <h2 class="tw-text-xl tw-font-bold">Similar cars you might like</h2>
  </div>
  <div class="col-sm-12 col-md-4" *ngFor="let car of cars;">
    <app-car-card [car]="car"></app-car-card>
  </div>
</div>